<template>
  <div class="information">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'咨讯中心'}]"></breadcrumb>
    <div class="information-wrap">
      <div class="information-contain">
        <page-title title="资讯列表">
          <div class="information-search">
            <el-date-picker v-model="daterange"
                            type="daterange"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            @change="getFirstPage"></el-date-picker>
            <el-select v-model="fileType"
            clearable
                       placeholder="请选择"
                       @change="getFirstPage">
              <el-option v-for="item in typeList"
                         :key="item.code"
                         :value="item.code"
                         :label="item.desc"></el-option>
            </el-select>
            <el-input v-model="fileName"
                      clearable
                      @clear=	"getFirstPage"
                      @keyup.enter.native="getFirstPage"
                      placeholder="输入文件名">
              <i slot="prefix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <div class="information-button_wrap">
              <input class="information-file_input"
                     type="file"
                     @change="selectFile"
                     ref="file">
              <el-button @click="showForm=true"
                         type="primary">
                <font-awesome-icon :icon="['fas', 'upload']" />
                <span style="margin-left:5px; font-size:14px;">添加文件</span>
              </el-button>
            </div>
          </div>
        </page-title>
        <div class="information-table-wrap">
          <div class="information-table">
            <table>
              <tr v-for="item in informationList"
                  :key="item.id">
                <td> {{item.fileName}}</td>
                <td><font-awesome-icon v-if="item.fileTypeName==='文档'" style="color:#F0722B;margin-right:8px;"
                                       :icon="['far', 'file']" /><font-awesome-icon v-else style="color:#F0722B;margin-right:5px;"
                                       :icon="['far', 'image']" />{{item.fileTypeName}}</td>
                <td style="color:#9B9B9B">{{item.updateTime.replace('T',' ')}}</td>
                <td>
                  <a :href="item.fileUrl" :download="item.fileName">
                  <el-button>
                    <font-awesome-icon style="color:#F0722B;margin-right:5px;"
                                       :icon="['fas', 'download']" />下载</el-button>
                                       </a>
                </td>
                <td>
                  <span @click.stop="popConfirm(item.id)"
                        style="cursor:pointer">
                    <font-awesome-icon style="color:#D44052;"
                                       :icon="['fas', 'minus-circle']" />
                  </span>
                </td>
              </tr>
            </table>
          </div>
          <el-pagination @current-change="changePage"
                         :current-page="page"
                         class="information-pagination"
                         background
                         layout="prev, pager, next"
                         :total="listSize"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog class="information-dialog"
               title="添加咨讯"
               :visible.sync="showForm">
      <el-form label-position="top">
        <el-form-item label="文件">
          <div class="information-file">
            <div v-if="file"
                 class="information-file_label">

              <font-awesome-icon style="color:#F0722B;margin-right:10px"
                                 :icon="['fas', 'download']" /> {{file.name}}
              <span style="margin-left:9px; cursor:pointer"
                    @click="delFile(index)">
                <font-awesome-icon :icon="['fas', 'times-circle']" />
              </span>

            </div>
            <el-button @click="addFile()"
                       type="primary">
              <font-awesome-icon :icon="['fas', 'upload']" />
              <span style="margin-left:5px; font-size:14px;">上传文件</span>
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="文件描述">
          <el-input v-model="fileDesc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="submit()">提 交</el-button>
        <el-button @click="showForm = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import pageTitle from '@/components/pageTitle'
export default {
  components: {
    breadcrumb,
    pageTitle
  },
  filters: {
    timeFilter(value) {
      return value.replace('T', ' ')
    }
  },
  data() {
    return {
      page: 1,
      listSize: 0,
      informationList: [],
      fileName: '',
      fileType: '',
      daterange: '',
      typeList: [],
      showForm: false,
      file: '',
      fileDesc: ''
    }
  },
  created() {
    this.getList()
    this.getTypeList()
  },
  methods: {
    //获取资讯列表
    getList() {
      let params = {
        page: this.page,
        pageSize: 10,
        fileName: this.fileName,
        fileType: this.fileType || '',
        startDate: this.daterange ? this.daterange[0] : '',
        endDate: this.daterange ? this.daterange[1] : ''
      }
      axios
        .post(api.getFileList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取资讯列表成功', res.data.result)
            this.informationList = res.data.result.records
            this.listSize = res.data.result.total
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //获取资讯类型
    getTypeList() {
      axios
        .get(api.fileTypeList)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取资讯类型列表成功', res.data.result)
            this.typeList = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    changePage(v) {
      this.page = v
      this.getList()
    },
    //上传文件
    addFile() {
      this.$refs['file'].click()
    },
    getFirstPage() {
      this.page = 1
      this.getList()
    },
    selectFile(e) {
      this.file = e.target.files[0]
      if (!this.file.length) {
        return
      }
    },
    submit() {
      let param = new FormData()
      param.append('file', this.file)
      param.append('fileDesc', this.fileDesc)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      axios
        .post(api.fileManageUpload, param, config)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '上传文件成功',
              type: 'success'
            })
            this.showForm = false
            this.page =1
            this.getList()
            console.log('上传文件成功', console.log(res.data))
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    // 删除附件
    delFile(index) {
      this.file = ''
    },
    popConfirm(id) {
      this.$confirm('删除后不可恢复，确认删除？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.deleteInfo(id)
        })
        .catch(() => {})
    },
    deleteInfo(id) {
      axios
        .get(api.removeFile + `?fileId=${id}`)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '删除资讯成功',
              type: 'success'
            })
            this.page =1
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    }
  }
}
</script>

<style lang="scss">
.information {
  .information-wrap {
    padding: 77px 30px 0px 30px;
    .information-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .information-search {
        display: flex;
        justify-content: flex-end;
        .information-button_wrap {
          .information-file_input {
            display: none;
          }
        }
        .el-input {
          width: 148px;
          margin-right: 15px;
        }
        .el-input__inner {
          width: 148px;
        }
        .el-range-editor {
          width: 250px;
          margin-right: 15px;
        }
      }
      .information-table-wrap {
        padding: 30px;
        .information-table {
          min-height: 470px;
          td {
            padding:0px 17px;
            height: 47px;
            line-height: 47px;
          }
          .el-button {
            height: 30px;
            line-height: 30px;
            padding: 0px 14px;
          }
        }
        .information-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .information-dialog {
    .information-file {
      display: flex;
      .information-file_label {
        margin-right: 10px;
        border-radius: 4px;
        border: 1px solid rgba(230, 227, 227, 1);
        padding: 0px 15px;
      }
    }
  }
}
</style>
